 
import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';
import CalculateIcon from '@mui/icons-material/Calculate';
import DescriptionIcon from '@mui/icons-material/Description';

export type NavItem = {
  text: string;
  href: string;
  external?: boolean;
  icon?: React.ReactNode;
};

export const DRAWER_WIDTH = 260;

export const navItems: NavItem[] = [
  { text: 'Atlyginimo skaičiuoklė', href: '/', icon: <HomeIcon fontSize="small" /> },
  { text: 'Darbo laiko kalendorius', href: '/darbo-laiko-kalendorius/', icon: <DescriptionIcon fontSize="small" /> },
  { text: 'Minimali alga', href: '/minimali-alga/', icon: <EuroSymbolIcon fontSize="small" /> },
  { text: 'NPD', href: '/npd/', icon: <CalculateIcon fontSize="small" /> },
  { text: 'Atostogų prašymas', href: '/darbo-laiko-kalendorius/atostogu-prasymas/', icon: <DescriptionIcon fontSize="small" /> },
];

export default navItems;
